(function() {
    angular.module('tmx-app').factory('UsersDynamicService', ['$http', 'tmxResource', '$q', 'tmxUtility', 'lookupService', function($http, tmxResource, $q, tmxUtility, lookupService) {
        var Users = tmxResource("User");
        Users.getAllUsers = function() {
            return Users.all();
        };

        Users.getById = function(id, successcb, errorcb) {
            var httpPromise = $http.get(Users.url + '/GetById/' + id); /*, {headers: {'Authorization': token}});*/
            return Users.thenFactoryMethod(httpPromise, successcb, errorcb);
        };

        Users.DesignationsLov = function(successcb, errorcb) {
            var httpPromise = $http.get(Users.url + '/designation');
            return Users.thenFactoryMethod(httpPromise, successcb, errorcb, true);
        };

        Users.ManagersLov = function(successcb, errorcb) {
            var httpPromise = $http.get(Users.url + '/manager');
            return Users.thenFactoryMethod(httpPromise, successcb, errorcb, true);
        };

        Users.deleteById = function(id) {
            var deferred = $q.defer();
            var item = Users.getById(id).then(function(result) {
                deferred.resolve(result.$remove());
            });
      // item.$remove();
            return deferred.promise;
        };

        lookupService.getUserTypes().then(function(types) {
            Users.type = types;
            Users.gridColumn[3].data = types;
            Users.gridColumn[4].data = types;
            Users.recievedLov = true;
        });

        Users.status = [
            { HiddenValue: "active",
                VisibleValue: "Active"
            },
            { HiddenValue: "inactive",
                VisibleValue: "Inactive"
            }
        ];

        Users.gridColumn = [
            {
                field: "UserName",
                title: "User Name",
                type: "string",
                template: "<md-button class='tmx-primary-text' ng-disabled='!UsersDynamicCtrl.isStatusActive(dataItem)' ng-click='UsersDynamicCtrl.clickEdit(dataItem)'> \{\{UsersDynamicCtrl.formatUserName(dataItem)\}\}   <md-tooltip md-direction='top'>#=UserName#</md-tooltip>  </md-button>"
            }, {
                field: "Designation",
                title: "Designation",
                type: "string"
            }, {
                field: "PhoneNumber1",
                title: "Phone",
                type: "string",
        // template: "UsersDynamicCtrl.getDevicePhoneNumber(#= DeviceId #)",
                sortable: false
            }, {
                field: "UserTypeLkp",
                title: "Branch",
                type: "select",
                data: Users.userType,
                isNumber: true
            }, {
                field: "UserTypeLkp",
                title: "User Type",
                type: "select",
                data: Users.userType,
                isNumber: true
            }, {
                field: "Status",
                title: "Status",
                type: "select",
                data: Users.status
            }
        ];

        Users.columns = angular.copy(Users.gridColumn);
    // Users.columns.push(
    //                             {command :[
    //                               {
    //                                  name: "Delete",
    //                                  text: "",
    //                                  template: "<md-button ng-disabled='UserCtrl.isStatusActive(dataItem)' aria-label='del' class='topbar-menu-button' ng-click='UserCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button>",
    //                               },
    //                               {
    //                                   name: "Edit",
    //                                   text: "",
    //                                   template: "<md-button ng-disabled='UserCtrl.isStatusActive(dataItem)' aria-label='del' class='topbar-menu-button' ng-click='UserCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /></md-button>",
    //                               },
    //                               {
    //                                   name: "Copy",
    //                                   text: "",
    //                                   template: "<tmx-duplicate disable='UserCtrl.isStatusActive(dataItem)' model='dataItem'  schema='UserCtrl.schema' columns='UserCtrl.cloneColumn' on-submit='UserCtrl.reload()'> </tmx-duplicate>",
    //                               }
    //                              ]});
        Users.schema = {
            UserId: {
                duplicate: false,
                unique: false
            },
            UserCode: {
                duplicate: true,
                unique: true
            }
        };
        Users.bulkDelete = function(array) {
            calls = [];

            function register(company, index) {
                calls.push({
                    key: company.UserName,
                    promise: company.$remove()
                });
            }
            array.forEach(register);
            tmxUtility.getAsynch($q, calls).then(function(result) {
            });
        };
        return Users;
    }]);
})();
